var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertMoveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0662B9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,14.5c0.2-0.2,0.6-0.2,0.9,0l0,0L9,16.2l1.8-1.8c0.2-0.2,0.6-0.2,0.9,0c0.2,0.2,0.2,0.6,0,0.9l-2.2,2.2 c-0.2,0.2-0.6,0.2-0.9,0l-2.2-2.2C6.1,15.1,6.1,14.7,6.4,14.5L6.4,14.5L6.4,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,10.9c0.3,0,0.6,0.3,0.6,0.6v5.6c0,0.3-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6v-5.6C8.4,11.2,8.7,10.9,9,10.9z  M8.6,0.4c0.2-0.2,0.6-0.2,0.9,0l2.2,2.2c0.2,0.2,0.2,0.6,0,0.9c-0.2,0.2-0.6,0.2-0.9,0l0,0L9,1.8L7.2,3.5C7,3.8,6.6,3.8,6.4,3.5 s-0.2-0.6,0-0.9l0,0L8.6,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,0.3c0.3,0,0.6,0.3,0.6,0.6v5.6c0,0.3-0.3,0.6-0.6,0.6S8.4,6.8,8.4,6.5V0.9C8.4,0.5,8.7,0.3,9,0.3z  M3.5,6.4c0.2,0.2,0.2,0.6,0,0.9l0,0L1.8,9l1.8,1.8c0.2,0.2,0.2,0.6,0,0.9c-0.2,0.2-0.6,0.2-0.9,0l0,0L0.4,9.4 c-0.2-0.2-0.2-0.6,0-0.9l2.2-2.2C2.9,6.1,3.3,6.1,3.5,6.4L3.5,6.4L3.5,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.3,9c0-0.3,0.3-0.6,0.6-0.6h5.6c0.3,0,0.6,0.3,0.6,0.6S6.8,9.6,6.5,9.6H0.9C0.5,9.6,0.3,9.3,0.3,9z  M14.5,6.4c0.2-0.2,0.6-0.2,0.9,0l0,0l2.2,2.2c0.2,0.2,0.2,0.6,0,0.9l-2.2,2.2c-0.2,0.2-0.6,0.2-0.9,0c-0.2-0.2-0.2-0.6,0-0.9 L16.2,9l-1.8-1.8C14.2,7,14.2,6.6,14.5,6.4L14.5,6.4L14.5,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,9c0-0.3,0.3-0.6,0.6-0.6h5.6c0.3,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6h-5.6C11.2,9.6,10.9,9.3,10.9,9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertMoveIcon);
export default __webpack_public_path__ + "static/media/alert_move_icon.d06a6d6a1aabf826d923f6d65d76fce6.svg";
export { ForwardRef as ReactComponent };